/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import React, { useState } from 'react';
import { ExclamationIcon } from "@heroicons/react/solid";
import pic from './login-bg.jpg';
import styled from 'styled-components';
const DivStyled = styled.div`
  background-image: url(${pic});
  background-size: cover;
`
const SignUpError = () => {
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationIcon
            className="h-5 w-5 text-yellow-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            The passwords entered twice do not match, please re-enter.
          </p>
        </div>
      </div>
    </div>
  );
};
export default function SignUp({ formState, signUp, updateFormState, goToSignIn }) {
  const [createButton, setCreateButton] = useState(true);
  const [emailAddress, setEmailAdress] = useState("");
  const [signUpError, setSignUpError] = useState(false);
  const comparePassword = () => {
    // if (password !== confirmPassword) {
    //   setSignUpError(true)
    // }
  }
  const handleSignUp = () => {
    if (formState.password !== formState.confirmPassword) {
      setSignUpError(true)
      return
    }
    signUp(formState, 'signUp')
  }
  return (
    <DivStyled className="h-screen bg-gray-50 flex flex-col py-12 sm:px-6 lg:px-8">
      {/* logo */}
      <a className="flex items-center" href="https://singularity.ai/">
        <img
          className="h-12 w-auto mr-4"
          src="/logo512.png"
          alt="logo"
        />
        <img
          className="w-auto"
          src="/logo-text.png"
          alt="logo-text"
        />
      </a>

      <div className="mt-16 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Create your free account</h2>
          <div className="hidden">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Username
            </label>
            <div className="mt-1">
              <input
                id="username"
                name="username"
                type="text"
                placeholder="Username"
                autoComplete="username"
                value={emailAddress}
                onChange={e => { e.persist(); updateFormState(e); }}
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
              />
            </div>
          </div>

          <div className="pt-4">
            <label htmlFor="email" className="blockblock text-sm font-medium text-gray-700">
              Your email
            </label>
            <div className="mt-1">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="name@example.com"
                autoComplete="email"
                onChange={e => { e.persist(); updateFormState(e); setEmailAdress(e.target.value); }}
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label htmlFor="password" className="pt-4 block text-sm font-medium text-gray-700">
              Password
            </label>
            <div className="mt-1">
              <input
                id="password"
                name="password"
                type="password"
                placeholder="Password"
                autoComplete="current-password"
                required
                onChange={e => { e.persist(); updateFormState(e); setSignUpError(false) }}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"

              />
            </div>
          </div>
          <div className="pt-4">
            <label htmlFor="email" className="blockblock text-sm font-medium text-gray-700">
              Confirm password
            </label>
            <div className="mt-1">
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                placeholder="Confirm password"
                autoComplete="email"
                onChange={e => { e.persist(); updateFormState(e); setSignUpError(false) }}
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
              />
            </div>
          </div>


          <div className="py-4 flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="iagree"
                name="iagree"
                type="checkbox"
                className="h-4 w-4 text-sprimary-600 focus:ring-sprimary-500 border-gray-300 rounded peer"
                onChange={(e) => { setCreateButton(!e.target.checked); }}
              />
              <p className="ml-2 text-left text-sm text-gray-600">
                I agree to the<a href="https://singularity.ai/company-overview/" target="_blank" className="text-sprimary-600 font-medium background-transparent px-2 py-1  text-left [text-base outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                  Terms and Conditions
                </a>
              </p>
            </div>
          </div>
          <button
            type="submit"
            className={createButton ? "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sprimary-100 hover:bg-sprimary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sprimary-200 cursor-not-allowed" : "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sprimary-600 hover:bg-sprimary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sprimary-500 cursor-auto"}
            onClick={() => handleSignUp(formState, 'signUp')}
            disabled={createButton}
          >
            Create account
          </button>
          {signUpError && <SignUpError />}
          <div className="text-sm text-center mt-2">
            Already have an account?
            <button className="text-sprimary-600 font-medium background-transparent px-3 py-1 text-base outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" onClick={goToSignIn}>
              Sign in instead
            </button>
          </div>
          <div>
          </div>
        </div>
      </div>
    </DivStyled>
  );
}
